// extracted by mini-css-extract-plugin
export var dividerContainer = "_9c-0";
export var line = "_9c-1";